module.exports = __webpack_public_path__ + "icon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/icon.png
// module id = 364
// module chunks = 0